// ARKA — remendos de acessibilidade em componentes de terceiros (FONTE CANÔNICA: design/arka/).
// Só adiciona aria-label/title onde a lib renderiza botão só com ícone. Não muda comportamento.
const LABELS = [
  ['.data-table-extensions-action > button.download', 'Exportar tabela'],
  ['.data-table-extensions-action > button.print', 'Imprimir tabela'],
  ['.data-table-extensions-filter > .filter-text', 'Filtrar tabela'],
  ['.rdt_Pagination select', 'Linhas por página'],
];

function patch(root) {
  LABELS.forEach(([sel, label]) => {
    root.querySelectorAll(sel).forEach((el) => {
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', label);
    });
  });
}

export default function installArkaA11y() {
  if (typeof window === 'undefined' || typeof MutationObserver === 'undefined') return;
  const run = () => patch(document);
  let queued = false;
  const obs = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; run(); });
  });
  const start = () => { run(); obs.observe(document.body, { childList: true, subtree: true }); };
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
}
